<template>
	<el-dialog :title="title" :close-on-click-modal="false" :visible.sync="visible" width="1000px">
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="115px"  class="border-form" :inline="true"
			style="margin-right: 25px;">
			<el-row class="set_border">
				<el-col :span="12" class="col-set_border">
					<el-form-item label="标的物" class="item">
						{{ dataForm.subjectName }}
					</el-form-item>
				</el-col>
				<!-- <el-col :span="8" class="set_border">
					<el-form-item label="范畴" class="item">
						{{ dataForm.categoryName }}
					</el-form-item>
				</el-col> -->
				<el-col :span="12" >
					<el-form-item label="专业" class="item">
						{{ dataForm.majorName }}
					</el-form-item>
				</el-col>
			</el-row>
			<el-row  class="set_border">
				<el-col :span="12" class="col-set_border">
					<el-form-item label="检验人" class="item">
						{{ dataForm.testMan }}
					</el-form-item>
				</el-col>
				<el-col :span="12" class="set_border">
					<el-form-item label="检验时间" class="item">
						{{ dataForm.testDate | formatDate('yyyy-MM-dd') }}
					</el-form-item>
				</el-col>
			</el-row>
			<el-row  class="set_border">
				<el-col :span="6" class="col-set_border">
					<el-form-item label="检验结论" class="item">
					</el-form-item>
				</el-col>
				<el-col :span="6" class="col-set_border">
					<el-form-item label="一次检验" class="item">
						<span>{{ dataForm.testConclusionName }}</span>
					</el-form-item>
				</el-col>
				<el-col :span="6" class="col-set_border">
					<el-form-item label="2次检验" class="item">
						<span>{{ dataForm.testConclusionName2 }}</span>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="2次以上检验" class="item">
						<span>{{ dataForm.testConclusionName3 }}</span>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="set_border">
				<el-col :span="24">
					<el-form-item label="检验项目" class="item">
						{{ dataForm.probContext }}
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="set_border">
				<el-col :span="24">
					<el-form-item label="检验意见" class="item">
						{{ dataForm.sutContent }}
					</el-form-item>
				</el-col>
			</el-row>
			<el-row  class="set_border">
				<el-col :span="12" class="col-set_border">
					<el-form-item label="封闭时间" class="item">
						{{ dataForm.closeTime | formatDate('yyyy-MM-dd') }}
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="封闭人" class="item">
						{{ dataForm.closeMan }}
					</el-form-item>
				</el-col>
			</el-row>
			<el-row  class="set_border">
				<el-col :span="24" class="set_border">
					<el-form-item label="备注" class="item">
						{{ dataForm.remark }}
					</el-form-item>
				</el-col>
			</el-row>
			<el-row  class="row-form-item">
				<el-col :span="24">
					<el-form-item label="整改前照片" class="fileItem">
					</el-form-item>
				</el-col>
			</el-row>
			<el-row  class="row-form-item">
				<el-col :span="24" style="margin-left: 30px;">
					<div class="addImgBox" v-for="(item, index) in dataForm.scenePhotoList"
						style="margin-top: 5px;margin-bottom: 10px;">
						<el-image style="width: 100%; height: 100%" :src="item.fileUri" fit="cover"></el-image>
					</div>
					<div v-if="!dataForm.scenePhotoList || dataForm.scenePhotoList.length === 0"
						style="margin-top: 10px;margin-bottom: 10px;margin-left: 90px;">
						<span style="color: #e7b243;">暂无整改前照片</span>
					</div>
				</el-col>
			</el-row>
			<el-row  class="row-form-item">
				<el-col :span="24">
					<el-form-item label="整改后照片" class="fileItem">
					</el-form-item>
				</el-col>
			</el-row>
			<el-row  class="row-form-item">
				<el-col :span="24" style="margin-left: 30px;">
					<div class="addImgBox" v-for="(item, index) in dataForm.closePhotoList"
						style="margin-top: 5px;margin-bottom: 10px;">
						<el-image style="width: 100%; height: 100%" :src="item.fileUri" fit="cover"></el-image>
					</div>
					<div v-if="!dataForm.closePhotoList || dataForm.closePhotoList.length === 0"
						style="margin-top: 10px;margin-bottom: 10px;margin-left: 90px;">
						<span style="color: #e7b243;">暂无整改后照片</span>
					</div>
				</el-col>
			</el-row>
			<el-row  class="row-form-item">
				<el-col :span="24">
					<el-form-item label="封闭文件" class="fileItem">
					</el-form-item>
				</el-col>
			</el-row>
			<el-row  class="row-form-item">
				<el-col :span="24" style="margin-left: 30px;margin-bottom: 10px;">
					<el-table :data="dataForm.closeFileList" :cell-style="{ padding: '0px' }" style="margin-bottom: 20px;"
						:show-header="false" v-if="dataForm.closeFileList && dataForm.closeFileList.length > 0">
						<el-table-column width="100" align="center" type="index">
						</el-table-column>
						<el-table-column prop="fileName" width="600" align="center">
						</el-table-column>
						<el-table-column width="165" align="center">
							<template slot-scope="scope">
								<el-button v-preventReClick type="text" size="small"
									@click="selectFile(scope.row.fileUri, scope.row.fileName)">查看</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div v-if="!dataForm.closeFileList || dataForm.closeFileList.length === 0"
						style="margin-top: 10px;margin-bottom: 10px;margin-left: 90px;">
						<span style="color: #e7b243;">暂无封闭文件</span>
					</div>
				</el-col>
			</el-row>
			<el-row class="formBtnGroup" style="margin-top: 40px;">
				<el-button v-preventReClick class="btn" type="primary" size="small" @click="visible = false">取消</el-button>
			</el-row>
		</el-form>
	</el-dialog>
</template>

<script>
import addImg from "@/assets/images/addImg.png"
import $common from "@/utils/common.js"
export default {
	name: "patrolList-Info",
	data() {
		return {
			title: '详情',
			addImg: addImg,
			categoryList: [],
			sutConclusionList: [],
			testId: '',
			visible: true,
			action: "",
			form: {},
			probCheck: '0',
			dataForm: {
				workNo: $common.getItem("workNo"),
				subjectNo: "",
				inspectionId: "",
				category: '',
				major: "",
				inspectionTime: "",
				inspectionPlace: "",
				inspectionMan: '',
				inspectionContent: '',
				photo: [],
				sutContent: '',
				problem: {}
			},
			dataRule: {
			}
		};
	},
	components: {

	},
	mounted() {
		// this.testId = this.$route.query.testId;
		// this.getDetail();
	},
	filters: {
		formatDate: function (value, args) {
			if (!value) {
				return ''
			}
			var dt = new Date(value);
			if (args == 'yyyy-M-d') {// yyyy-M-d
				let year = dt.getFullYear();
				let month = dt.getMonth() + 1;
				let date = dt.getDate();
				return `${year}-${month}-${date}`;
			} else if (args == 'yyyy-M-d H:m:s') {// yyyy-M-d H:m:s
				let year = dt.getFullYear();
				let month = dt.getMonth() + 1;
				let date = dt.getDate();
				let hour = dt.getHours();
				let minute = dt.getMinutes();
				let second = dt.getSeconds();
				return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
			} else if (args == 'yyyy-MM-dd') {// yyyy-MM-dd
				let year = dt.getFullYear();
				let month = (dt.getMonth() + 1).toString().padStart(2, '0');
				let date = dt.getDate().toString().padStart(2, '0');
				return `${year}-${month}-${date}`;
			} else {// yyyy-MM-dd HH:mm:ss
				let year = dt.getFullYear();
				let month = (dt.getMonth() + 1).toString().padStart(2, '0');
				let date = dt.getDate().toString().padStart(2, '0');
				let hour = dt.getHours().toString().padStart(2, '0');
				let minute = dt.getMinutes().toString().padStart(2, '0');
				let second = dt.getSeconds().toString().padStart(2, '0');
				return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
			}
		}
	},
	methods: {
		goBack() {
			this.$router.back()
		},
		init(id) {
			// this.getCategoryList();
			this.dataForm.testId = id ? id : '';
			if (id) {
				this.getDetail();
			}
			this.$nextTick(() => {
				this.visible = true;
			});
			if (this.$refs) {
				this.$refs["dataForm"].resetFields();
			}

		},
		selectFile(url, filename) {
			filename = this.getSuffix(url, filename)
			this.getBlob(url, (blob) => {
				this.saveAs(blob, filename)
			})
		},
		getSuffix(url, filename) {
            let lastIndex = url.lastIndexOf(".");
            return filename + url.substr(lastIndex)
        },
		getBlob(url, cb) {
			var xhr = new XMLHttpRequest()
			xhr.open('GET', url, true)
			xhr.responseType = 'blob'
			xhr.onload = function () {
				if (xhr.status === 200) {
					cb(xhr.response)
				}
			}
			xhr.send()
		},
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			}
			else {
				var link = document.createElement('a')
				var body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob)
				link.download = filename

				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)
				window.URL.revokeObjectURL(link.href)
			}
		},
		getDetail() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/testrecord/info/" + this.dataForm.testId,
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.dataForm = data.body;
					this.title = "详情" + " " + this.dataForm.recSortCode
				}
			});
		},
		getCategoryList() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getCategoryList",
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.categoryList = data.body;
				}
			});
		},
		getCategoryName(categoryId) {
			this.categoryList.forEach((item) => {
				if (categoryId === item.displayValue) {
					return item.displayName
				}
			})
		},
	}
};
</script>

<style lang="scss" scoped>
.row-form-item {
    margin-top: 10px;
}

.row-form-item .el-form-item {
    margin-right: 0;
}


.border-form  .el-row.set_border {
    border-bottom: 1px solid #dadada;;
    border-left:1px solid #dadada;;
    border-right:1px solid #dadada;;
}

.border-form  .el-row.set_border:first-child {
    border-top:1px solid #dadada;;
}

.border-form  .el-row.set_border .col-set_border {
    border-right:1px solid #dadada;
}

.item::v-deep .el-form-item__label {
	color: #00428e !important;
	margin-right: 10px !important;
	;
	font-weight: bold !important;
	;
	background-color: #E1F1FF;
	height: 40px !important;
	border-right:1px solid #dadada;;
}

::v-deep .el-form-item {
    display: flex !important;
    align-items: stretch !important;
    margin-bottom: 0px !important;
}

.fileItem::v-deep .el-form-item__label {
	text-align: left;
	padding-left: 20px;
	color: #00428e !important;
	margin: 5px 0px 10px 0px !important;
	;
	font-weight: bold !important;
	;
	width: 915px !important;
	background-color: #E1F1FF;
}

.selItemInput.descAreaLg {
	width: 718px !important;
}

.selItemInput.descAreaLg1 {
	width: 918px !important;
}

.addImgBox {
	width: 136px;
	height: 136px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 10px;
}
</style>
